import { graphql, useStaticQuery } from 'gatsby';

export const useProductPersonalisedText = () => {
  const content = useStaticQuery(graphql`
    query ProductPersonalised {
      directusProductPersonalised {
        page_title
        page_title_trial
        page_description
        page_description_trial
        hero_title
        hero_title_trial
        hero_description
        hero_description_no_price
        hero_description_trial
        hero_button_label
        hero_image {
          title
          filename_disk
        }
        hero_footnote
        hiw_title
        hiw_items {
          title
          description
          filename_disk
        }
        personal_title
        personal_description
        personal_items {
          filename_disk
        }
        quality_title
        quality_description
        quality_image_1 {
          filename_disk
        }
        quality_image_2 {
          filename_disk
        }
        feel_best_title
        feel_best_title_trial
        feel_best_description
        feel_best_description_no_price
        feel_best_description_trial
        feel_best_button_label
        feel_best_image {
          filename_disk
          title
        }
        reviews_title
        reviews_items {
          reviewerName
          review
        }
      }
      directusHome {
        expert_approval_title
        expert_approval_description
        experts {
          name
          qualification
          role
          image {
            title
            filename_disk
          }
        }
      }
      directus30Off3Month {
        hero_title
        hero_title_trial
        hero_description
        hero_button_label
        free_uk_delivery
        pause_or_cancel
        feel_best_title
        feel_best_description
      }
    }
  `);
  return content;
};
